import React, { useState } from "react"
import { Input } from "reactstrap"

// BDSJEA-229: input de contraseña con el icono de mostrar/ocultar (bx-show /
// bx-hide) posicionado DENTRO del borde del input, en vez del patron
// InputGroup + InputGroupText de reactstrap (que lo renderiza como una caja
// aparte, hermana del input). El estado de visibilidad vive aca adentro, no
// como prop: asi cada instancia (Login, o cada uno de los 3 campos de
// CambiarClave) tiene su propio toggle independiente sin que el padre tenga
// que manejar un useState por campo.
const PasswordInput = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "",
  invalid = false,
  disabled = false,
  autoComplete,
  className = "",
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    if (disabled) return
    setShowPassword(prev => !prev)
  }

  return (
    <div style={{ position: "relative" }}>
      <Input
        name={name}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        invalid={invalid}
        disabled={disabled}
        autoComplete={autoComplete}
        className={className}
        style={{
          paddingRight: "2.5rem",
          // Bootstrap (enable-validation-icons) pinta su propio icono de
          // validacion en el borde derecho cuando invalid=true, que se
          // superpondria con el ojito. El error ya se comunica con el
          // FormFeedback de texto debajo, asi que se anula el icono nativo.
          ...(invalid ? { backgroundImage: "none" } : {}),
        }}
      />
      <i
        className={`bx ${showPassword ? "bx-hide" : "bx-show"}`}
        role="button"
        tabIndex={0}
        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
        onClick={toggleShowPassword}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            toggleShowPassword()
          }
        }}
        style={{
          position: "absolute",
          top: "50%",
          right: "0.75rem",
          transform: "translateY(-50%)",
          cursor: disabled ? "default" : "pointer",
          color: "#74788d",
        }}
      />
    </div>
  )
}

export default PasswordInput
